import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';
import AccountingObject from './accountingObject';
import { combineClasses } from '../../../../utils/styling';

export const AccountingObjects = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Grid
        item
        container
        xs={2}
        sm={1}
        justifyContent="center"
        alignItems="center"
        className={classes.tableHeader}
      >
        <label
          className={combineClasses([
            classes.Bold,
            classes.Required,
            classes.UpperCase,
          ])}
        >
          {t('accountingObject.index')}
        </label>
      </Grid>
      <Grid
        item
        container
        xs={5}
        justifyContent="center"
        alignItems="center"
        className={classes.tableHeader}
      >
        <label
          className={combineClasses([
            classes.Bold,
            classes.Required,
            classes.UpperCase,
          ])}
        >
          {t('accountingObject.name')}
        </label>
      </Grid>
      <Grid
        item
        container
        xs={2}
        md={1}
        justifyContent="center"
        alignItems="center"
        className={classes.tableHeader}
      >
        <label
          className={combineClasses([
            classes.Bold,
            classes.Required,
            classes.UpperCase,
          ])}
        >
          {t('accountingObject.inUse')}
        </label>
      </Grid>
      <Grid
        item
        container
        xs={3}
        sm={4}
        md={5}
        className={classes.tableHeader}
      />
      {props.accountingObjects.map(object => (
        <AccountingObject
          key={object.index}
          object={object}
          changeObject={props.changeObject}
        />
      ))}
    </>
  );
};

AccountingObjects.propTypes = {
  accountingObjects: PropTypes.array,
  changeObject: PropTypes.func,
};
